module.exports = __webpack_public_path__ + "img/colorful-char3.814421e1.png";